export default 'Blog — Veille marché énergie, CEE, rénovation | Solution Éco France';
